export const ReactivityUtil = {
  resetData(reactiveWrapper) {
    if (Array.isArray(reactiveWrapper)) {
      reactiveWrapper.splice(0, reactiveWrapper.length)
    } else {
      for (const key of Object.keys(reactiveWrapper)) {
        delete reactiveWrapper[key]
      }
    }
  },
  // Handle reactive array and object data assignment
  reAssign(reactiveWrapper, newData) {
    if (Array.isArray(reactiveWrapper)) {
      reactiveWrapper.splice(0, reactiveWrapper.length, ...newData)
    } else {
      this.resetData(reactiveWrapper)
      Object.assign(reactiveWrapper, newData)
    }
  },
}
